module.exports = __webpack_public_path__ + "media/components/src/assets/images/method/amex-3e8c4d54f0b8957b0b84ec86a31592f0.png";